/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Permissionname1Inputs */

const en_entity_permissionname1 = /** @type {(inputs: Entity_Permissionname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission Name`)
};

const de_entity_permissionname1 = /** @type {(inputs: Entity_Permissionname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Permission Name" |
*
* @param {Entity_Permissionname1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_permissionname1 = /** @type {((inputs?: Entity_Permissionname1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Permissionname1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_permissionname1(inputs)
	return de_entity_permissionname1(inputs)
});
export { entity_permissionname1 as "entity_permissionName" }